'use client'

import { css, cx } from '@/styled-system/css'
import { splitCssProps } from '@/styled-system/jsx'
import {
  scrollArea,
  type ScrollAreaVariantProps,
} from '@/styled-system/recipes'
import type { Assign, JsxStyleProps } from '@/styled-system/types'
import * as PrimitiveScrollArea from '@radix-ui/react-scroll-area'
import { forwardRef } from 'react'

export interface ScrollAreaProps
  extends Assign<JsxStyleProps, PrimitiveScrollArea.ScrollAreaProps>,
    ScrollAreaVariantProps {}

export const ScrollArea = forwardRef<HTMLDivElement, ScrollAreaProps>(
  (props, ref) => {
    const [variantProps, scrollAreaProps] = scrollArea.splitVariantProps(props)
    const [cssProps, localProps] = splitCssProps(scrollAreaProps)
    const { children, className, ...rootProps } = localProps
    const styles = scrollArea(variantProps)

    return (
      <PrimitiveScrollArea.Root
        ref={ref}
        className={cx(styles.root, css(cssProps), className)}
        {...rootProps}
      >
        <PrimitiveScrollArea.Viewport className={styles.viewport}>
          {children}
        </PrimitiveScrollArea.Viewport>
        <PrimitiveScrollArea.Scrollbar
          className={styles.scrollbar}
          orientation='vertical'
        >
          <PrimitiveScrollArea.Thumb className={styles.thumb} />
        </PrimitiveScrollArea.Scrollbar>
        <PrimitiveScrollArea.Scrollbar
          className={styles.scrollbar}
          orientation='horizontal'
        >
          <PrimitiveScrollArea.Thumb className={styles.thumb} />
        </PrimitiveScrollArea.Scrollbar>
        <PrimitiveScrollArea.Corner className={styles.corner} />
      </PrimitiveScrollArea.Root>
    )
  }
)

ScrollArea.displayName = 'ScrollArea'
